export default "__VITE_ASSET__BEv7li9Q__"